import { AppMain, Sidebar } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import { mapState } from "vuex";
import Screenfull from "../components/Screenfull";
import { updateUserAvatar } from "@/api/system1/user";
import EIUploadOnePic from "@/components/EIUploadOnePic";
import { setTenantId } from "@/utils/auth.js";
export default {
  name: "Layout",
  components: {
    AppMain,
    Sidebar,
    Screenfull,
    EIUploadOnePic
  },
  props: {},
  data() {
    return {
      tenantOptions: [],
      tenantId: "",
      tenantSelectWidth: 100,
      iframeData: new Map([["/test1", "https://www.woyaojiangai.com/payment"]]),
      avatarFileList: [],
      currentDate: "",
      currentTime: "",
      timer: null
    };
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: state => state.common.sidebar,
      device: state => state.common.device,
      showSettings: state => state.common.showSettings,
      needTagsView: state => state.common.tagsView,
      fixedHeader: state => state.common.fixedHeader,
      visitedViews: state => state.common.visitedViews,
      userInfo: state => state.common.userInfo,
      tenantInfos: state => state.common.userInfo.tenantInfos || []
    }),
    showSideBar() {
      if (this.$route.path !== "/home") {
        return true;
      } else {
        return false;
      }
    },
    cachedViews() {
      return this.$store.state.common.cachedViews;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile"
      };
    },
    setting: {
      get() {
        return this.$store.state.common.showSettings;
      },
      set(val) {
        this.$store.dispatch("common/changeSetting", {
          key: "showSettings",
          value: val
        });
      }
    },
    currentIframe() {
      let path = this.$route.path;
      if (this.iframeData.get(path)) {
        return {
          src: this.iframeData.get(path)
        };
      } else {
        return false;
      }
    },
    iframeStyle() {
      return {
        width: "100%",
        padding: "16px",
        height: "100%",
        overflow: "hidden",
        border: 0
      };
    }
  },
  watch: {
    // 监听 userInfo.avatar 变化，更新 avatarFileList
    'userInfo.avatar': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.avatarFileList = [newVal];
        } else {
          // 没有头像时使用默认图片
          this.avatarFileList = [require('@/assets/img/defaultImg.png')];
        }
      }
    }
  },
  created() {},
  mounted() {
    window.onresize = () => {
      if (document.documentElement.clientWidth < 1020) {
        this.$store.state.common.sidebar.opened = false;
      } else {
        this.$store.state.common.sidebar.opened = true;
      }
    };
    // 判断租户下拉是否为0，为0提示
    if (!this.$store.state.common.userInfo.tenantInfos || this.$store.state.common.userInfo.tenantInfos?.length == 0) {
      this.$message({
        showClose: true,
        message: "当前用户无可管理租户，请联系超级管理员分配租户!",
        duration: 0,
        type: 'warning'
      });
    } else {
      // 除了超管，平台管理员和普通用户默认选中租户下拉第一个数据
      const savedTenantId = window.localStorage.getItem("tenantId");
      const isValidTenantId = savedTenantId !== null && savedTenantId !== "null" && savedTenantId !== "undefined" && !isNaN(Number(savedTenantId));
      if (this.$store.state.common.userInfo.userType != 3) {
        this.tenantId = isValidTenantId ? Number(savedTenantId) : this.$store.state.common.userInfo.tenantInfos[0].tenantId;
      } else {
        this.tenantId = isValidTenantId ? Number(savedTenantId) : "";
      }
      // 确保 tenantId 同步到 Cookie，避免请求头 Target-Tenant-Id 为 undefined
      if (this.tenantId) {
        setTenantId(this.tenantId);
      }
    }
    // 计算租户下拉框宽度
    this.calculateTenantSelectWidth();
    // 初始化时间
    this.updateTime();
    // 每秒更新时间
    this.timer = setInterval(() => {
      this.updateTime();
    }, 1000);
  },
  methods: {
    // 计算租户下拉框宽度
    calculateTenantSelectWidth() {
      const textWidth = text => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        ctx.font = '14px sans-serif';
        return ctx.measureText(text).width;
      };
      const options = this.tenantInfos;
      if (!options || options.length === 0) return;
      let maxWidth = 0;
      options.forEach(item => {
        const w = textWidth(item.tenantName || '');
        if (w > maxWidth) maxWidth = w;
      });

      // 添加padding和图标宽度，最小200px，最大400px
      this.tenantSelectWidth = Math.max(100, Math.min(100, maxWidth + 80));
    },
    // 切换租户id
    changeTenantId(val) {
      if (val) {
        this.$store.dispatch("common/changeTenantId", val);
      } else {
        this.$store.dispatch("common/changeTenantId", null);
      }
      location.reload(); // 整页刷新
      // this.$router.go(0); // 通过路由实例刷新
    },
    // 侧边栏展开收起
    toggleSideBar() {
      this.$store.dispatch("common/toggleSideBar");
    },
    handleClickOutside() {
      this.$store.dispatch("common/closeSideBar", {
        withoutAnimation: false
      });
    },
    async logout() {
      this.$confirm("确定注销并退出系统吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store.dispatch("common/LogOut").then(() => {
          location.reload();
        });
      });
    },
    // 更新用户头像
    handleAvatarFileListUpdate(fileListValue) {
      updateUserAvatar({
        avatarUrl: fileListValue
      });
    },
    // 更新时间
    updateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      const weekDay = weekDays[now.getDay()];
      this.currentDate = `${year}-${month}-${day} ${weekDay}`;
      this.currentTime = `${hours}:${minutes}:${seconds}`;
    },
    // 清理定时器
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    }
  }
};